import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreatePaymentTypeModel,
  DeletePaymentTypeModel,
  SearchPaymentTypeModel,
} from '../../../models/payment-type.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class PaymentTypeService {
  private baseUrl = environment.baseUrl
  private resource: string = 'TipoPagamento'

  constructor(private httpClient: HttpClient) {}

  public createPaymentType(
    model: CreatePaymentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editPaymentType(
    model: any,
    // model: EditPaymentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deletePaymentType(
    model: DeletePaymentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedPaymentType(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPaymentType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getPaymentTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedPaymentType(
    page: number,
    rows: number = 15,
    model: SearchPaymentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
